export default "__VITE_ASSET__106efd53__"